import { convertImgLink, useCdnBasePath } from '@ui/helpers'
import css from 'styled-jsx/css'

type OrdLineVariantProp = {
  orderLine: Types.OrderLine
}

export const OrdLineVariant = ({ orderLine }: OrdLineVariantProp) => {
  const basepath = useCdnBasePath()
  return (
    <>
      <style jsx>{compStyle}</style>
      <div className="pt-2">
        <div className="do-detail__property">
          <div className="quantity-variant-box mr-4">
            <span className="quantity-variant-box__num">{orderLine?.quantity} </span>
          </div>
          <div>
            <span className="mr-4">x</span>
          </div>
          {orderLine.variant_image?.includes('_400x400') ? (
            <video autoPlay loop muted playsInline className="">
              <source
                src={convertImgLink(orderLine.variant_image || '', basepath)}
                type="video/mp4"
              />
            </video>
          ) : (
            <img src={orderLine.variant_image} alt="" className="mr-4" sizes="48px" />
          )}

          <div>
            {orderLine.variant_properties?.map((property, index) => (
              <p key={index}>
                <strong>{property.name}</strong>: {property.value}
                <br />
              </p>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

const compStyle = css`
  .quantity-variant-box {
    border: 1px solid #e0e3e9;
    border-radius: 5px;
    padding: 4px 10px;
    min-width: 30px;
    min-height: 30px;

    &__num {
      height: 20px;

      padding: 2px;

      font-weight: 600;
      font-size: 14px;
      line-height: 20px;

      display: flex;
      align-items: center;
      text-align: center;
    }
  }

  .do-detail {
    p {
      font-size: 12px;
      line-height: 24px;
      max-width: 250px;
      margin-bottom: auto;
    }

    &__property {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      img {
        width: 48px;
        height: 48px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        border-radius: 4px;
      }

      &--quality {
        font-size: 16px;
        line-height: 32px;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
`
